
import { admin, guest } from 'apprise-core/auth';
import { User } from 'apprise-core/user';
import { utils } from 'apprise-core/utils';
import { useT } from 'apprise-frontend-core/intl/language';


// if the user is precanned it returns a clone that:
// 1. aligns with the latest version bundled with the app, in case it has deviated from the server's.
// 2. has a language sensitive name

export const usePrecannedUser = () => {

    const t = useT()

    return {

        of: (user: User) => {

            const firstname = user.username === guest.username ? guest.username : user.username === admin.username ? admin.username : undefined

            if (!firstname)
                return user

            const clone = utils().deepclone(user)
            
            clone.details.firstname = t(`user.precanned_${firstname}`)
            clone.details.lastname = ''

            return clone
        }

    }

}